import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
// import loginImage from '../../assets/images/login/loginPage.jpg';
import { useTranslation } from 'react-i18next';
import passwordIcon from '../../assets/icons/password1.png';
import BackgroundLogin from '../LoginNew/BackgroundLogin';
import { Input } from '../../shared/component/form/Input';
import Button from '../../shared/component/Button';
import auth from '../../utils/api/auth';
import loginImage from '../../assets/images/wejha_login_logo.png';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function ResetPasswordNew() {
  const { t } = useTranslation();
  const query = useQuery();
  const token = query.get('token');
  const [value, setValue] = useState({});
  const [errorMessage, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('data');
  }, [value]);

  const changeHandle = (name, changeValue) => {
    setValue({ ...value, [name]: changeValue });
  };
  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  const submit = () => {
    if (value.password === value.c_password) {
      // Validate the password before submitting
      if (validatePassword(value.password)) {
        auth.resetPassword({ password: value.password }, token)
          .then(() => {
            navigate('/login');
          })
          .catch((error) => {
            if (error?.response?.data?.code === 401) {
              setError(error?.response?.data?.message);
            }
            if (error?.response?.data?.code === 400) {
              setError(error?.response?.data?.message);
            }
          });
      } else {
        setError(
          'Password must contain 8 characters, contain one uppercase letter, one number, and one special character.',
        );
      }
    } else {
      setError('Password does not match.');
    }
  };
  const [currentIndex, setCurrentIndex] = useState(0);
  const videoRef = useRef(null);

  const videoData = [
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/weather.mp4',
      heading: t('wEATHER'),
      text: (
        t('weatherInfo')
      ),
    },
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/template.mp4',
      heading: t('tEMPLATES'),
      text: (
        t('templatesInfo')
      ),
    },
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/content.mp4',
      heading: t('cONTENTLAYOUT'),
      text: (
        t('contentLayoutInfo')
      ),
    },
  ];
  const handleVideoEnd = () => {
    setCurrentIndex((prev) => (prev + 1) % videoData.length);
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play();
    }
  }, [currentIndex]);

  return (
    <>
      <BackgroundLogin />
      <div className="register-container">
        <div className="banner-wrap">
          <div className="left-content">
            <img
              src={loginImage}
              alt="Logo"
              className="brand-logo"
            // style={{
            //   alignSelf: 'flex-start',
            //   display: 'block',
            //   margin: 0,
            //   padding: 0,
            // }}
            />
            <p className="caption-text">
              {t('effortlesslyCreate')}
              <span className="highlight-green"> {t('schedules')} </span>
              {t('andManage')}
              <span className="highlight-green"> {t('signage')}.</span>
            </p>
            <div className="tv-box">
              {/* You can place an image, animation, or SVG here */}
              <video
                ref={videoRef}
                src={videoData[currentIndex].src}
                autoPlay
                muted
                playsInline
                onEnded={handleVideoEnd}
                className="video-box"
              />
            </div>
            <div className="sub-tv">
              {/* sub tv */}
            </div>
            <div className="sub-title">
              <div className="heading">{videoData[currentIndex].heading}</div>
              <div className="sub-text">
                {videoData[currentIndex].text}
              </div>
            </div>
          </div>
        </div>
        <div className="register-form-wrap">
          {/* <div className="page"> */}
          <div className="form-session reset">
            <div className="form reset-login-forms">
              <h1 className="loginTitle">{t('resetYourPassword')}</h1>
              <p className="loginTitle1">{t('enterYournewPasswordBelowtoResetYourAccount')}</p>
              <p className="text-danger">{errorMessage}</p>
              <Input
                icon={passwordIcon}
                label="New Password"
                type="password"
                name="password"
                change={changeHandle}
                value={value?.password}
              />
              <Input
                icon={passwordIcon}
                label="Confirm Password"
                type="password"
                name="c_password"
                change={changeHandle}
                value={value.c_password}
              />
              <Button label="Reset Password" click={submit} classes="success-button" />
              <div className="loginButton">{t('rememberPassword')} <Link to="/login">{t('login')}</Link></div>
            </div>
            {/* </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPasswordNew;
